module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors,
      "useAuthentication": false
    }
  }, [_c('modal-service', {
    attrs: {
      "terms": _vm.config.serviceTerms
    },
    on: {
      "confirm": function($event) {
        return _vm.modalService()
      }
    },
    model: {
      value: (_vm.modalServiceFlag),
      callback: function($$v) {
        _vm.modalServiceFlag = $$v
      },
      expression: "modalServiceFlag"
    }
  }), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Termos de Uso"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', [(!_vm.config.serviceTerms.user || !_vm.config.serviceTerms.date) ? _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.serviceTerms.accepted),
      expression: "config.serviceTerms.accepted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.serviceTerms.accepted) ? _vm._i(_vm.config.serviceTerms.accepted, null) > -1 : (_vm.config.serviceTerms.accepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.serviceTerms.accepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.serviceTerms, "accepted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.serviceTerms, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.serviceTerms, "accepted", $$c)
        }
      }
    }
  }), _vm._v("\n            Declaro ter lido e aceitado os\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "terms-link",
    attrs: {
      "data-label": "Visualizar Termos e Politicas de Serviço"
    },
    on: {
      "click": function($event) {
        _vm.modalServiceFlag = true
      }
    }
  }, [_vm._v("\n            Termos e Politicas de Serviço\n          ")]), _vm._v(".\n          "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("É necessário aceitar os Termos e Politicas de Serviços para ativação e utilização da integração Amazon com PlaceMarket.")])]) : _c('div', [_c('a', {
    staticClass: "terms-link",
    attrs: {
      "data-label": "Visualizar Termos e Politicas de Serviço"
    },
    on: {
      "click": function($event) {
        _vm.modalServiceFlag = true
      }
    }
  }, [_vm._v("\n            Termos e Politicas de Serviço \n          ")]), _vm._v(" "), _c('p', {
    staticClass: "inline-text"
  }, [_vm._v("\n            já aceitos. \n          ")])])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('product-price-configuration', {
    attrs: {
      "input": _vm.config.product.price
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor de estoque padrão"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stock.reducer),
      expression: "config.product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.product.stock, "reducer", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('expediter-configuration', {
    attrs: {
      "expediter": _vm.config.order.expediter
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('order.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Tempo (em dias) para resgate de pedidos"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.daysToRetrieve),
      expression: "config.order.daysToRetrieve"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.order.daysToRetrieve)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.order, "daysToRetrieve", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Pedidos que foram atualizados no intervalo de dias configurado irão ser resgatados para o Hub.")])]), _vm._v(" "), _c('order-retrieve-date-configuration', {
    attrs: {
      "orderConfigs": _vm.config.order,
      "columns": 6
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Utilizar rotina específica para novos pedidos"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.useSpecificCronForNewOrders),
      expression: "config.order.useSpecificCronForNewOrders"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order, "useSpecificCronForNewOrders", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.useSpAPIOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0)]), _vm._v(" "), (_vm.config.order.useSpecificCronForNewOrders) ? _c('form-group', {
    attrs: {
      "label": "Tempo (em dias) para resgate de novos pedidos criados"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.daysToRetrieveOnlyNewOrders),
      expression: "config.order.daysToRetrieveOnlyNewOrders"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.order.daysToRetrieveOnlyNewOrders)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.order, "daysToRetrieveOnlyNewOrders", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Pedidos que foram criados no intervalo de dias configurado irão ser resgatados para o Hub.")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Webhook notificação de pedidos ",
      "columns": 12
    }
  }, [_vm._v("\n        " + _vm._s(_vm.urlWebhookOrderNotification) + "\n\n        "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.urlWebhookOrderNotification),
      expression: "urlWebhookOrderNotification",
      arg: "copy"
    }],
    staticClass: "btn btn--sm btn--info copy hint hint--top",
    attrs: {
      "type": "button",
      "data-label": "Clique para copiar"
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Sincronização"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar estoque",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.stock),
      expression: "config.synchronize.stock"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "stock", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os estoques serão sincronizados e atualizados na Amazon.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sincronizar preço",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.price),
      expression: "config.synchronize.price"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "price", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os preços serão sincronizados e atualizados na Amazon.")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8066c76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Amazon.vue
// module id = 3472
// module chunks = 0